import * as React from 'react';
import { DisplayDate, DisplayDateProps } from 'ui/display-date/display-date';
import { resolveEgressRecordedBy } from 'ui/egress-toggle-button/resolve-egress-recorded-by';
import styles from './egress-display-date.scss';

export interface EgressDisplayDateProps extends Partial<DisplayDateProps> {
  currentUser?: { value: string | number; description?: string };
  entryLogValues?: { egressTimeRecordedBy?: { value: string | number; description?: string } };
  rowEntity?: any;
  textLabelPrefix?: string;
}

/**
 * Read-only rendering of an egress date, including who recorded it.
 *
 * Mirrors the "recorded by" text shown next to the interactive `EgressToggleButton`
 * used in edit mode, without any of the toggle behavior.
 */
export const EgressDisplayDate: React.FC<EgressDisplayDateProps> = props => {

  const { rowEntity, currentUser, entryLogValues, textLabelPrefix, ...displayDateProps } = props;

  const recordedBy = resolveEgressRecordedBy(rowEntity, currentUser, entryLogValues);

  const recordedByText = recordedBy ? `${textLabelPrefix ? `${textLabelPrefix} ` : ''}${recordedBy}` : undefined;

  return (
    <div className={props.className} id={props.componentId}>
      <DisplayDate {...(displayDateProps as any)}/>
      {props.value && recordedByText ?
        <div className={styles.recordedBy}>
          <span className={styles.recordedByText}>{recordedByText}</span>
        </div> :
        null
      }
    </div>
  );
};
